export const translations = {
  pt: {
    nav: { about: "Apresentação", species: "Espécies", gallery: "Galeria", contact: "Contactos" },
    hero: {
      kicker: "Barragem de Alqueva — Alentejo, Portugal",
      titleLines: ["PESCA", "GUIADA NO", "ALQUEVA"],
      sub: "Jornadas de pesca desportiva no maior lago artificial da Europa. Achigã, lúcio-perca, lúcio-real e barbo — com quem conhece cada recanto da barragem.",
      ctaPrimary: "Marcar jornada",
      ctaSecondary: "Conhecer as espécies",
      coords: "38.1975° N — 7.4961° W",
      scroll: "Desliza para explorar",
    },
    marquee: ["ACHIGÃ", "LÚCIO-PERCA", "LÚCIO-REAL", "BARBO", "ALQUEVA"],
    about: {
      chapter: "Capítulo 01",
      title: "Apresentação",
      heading: "A barragem é o nosso território.",
      paragraphs: [
        "A CebolaFishing Guide nasceu da paixão pela pesca desportiva e pelo Grande Lago. Na barragem de Alqueva — o maior lago artificial da Europa, com mais de 1 100 quilómetros de margens — cada jornada é planeada ao detalhe: os pesqueiros certos, a época certa, a técnica certa.",
        "Do achigã que explode no topwater ao amanhecer, ao lúcio-perca que caça ao entardecer, passando pelo poderoso lúcio-real e pelo combativo barbo — guiamos pescadores de todos os níveis em experiências feitas à medida.",
        "Sozinho, com amigos ou em família: traga a vontade de pescar, nós tratamos do resto.",
      ],
      stats: [
        { value: "250 km²", label: "de espelho de água" },
        { value: "83 km", label: "de comprimento" },
        { value: "+1 100 km", label: "de margens" },
      ],
      imageCaption: "Golden hour no Grande Lago",
    },
    species: {
      chapter: "Capítulo 02",
      title: "Espécies",
      heading: "Quatro adversários. Um palco.",
      sub: "Cada espécie pede uma leitura diferente da água — e é aí que entra a nossa experiência.",
      techniqueLabel: "Técnicas",
      items: [
        {
          id: "achiga",
          name: "Achigã",
          latin: "Micropterus salmoides",
          desc: "O rei do Alqueva. Explosivo, territorial e viciante — o predador que faz a fama do Grande Lago.",
          technique: "Topwater · Vinil · Spinnerbait",
        },
        {
          id: "lucio-perca",
          name: "Lúcio-perca",
          latin: "Sander lucioperca",
          desc: "Caçador crepuscular de dentes afiados. Exige paciência, precisão e leitura de fundos.",
          technique: "Vertical · Jigging · Zagaia",
        },
        {
          id: "lucio-real",
          name: "Lúcio-real",
          latin: "Esox lucius",
          desc: "O emboscador. Ataques fulminantes junto à estrutura — adrenalina pura em cada lançamento.",
          technique: "Jerkbait · Swimbait · Superfície",
        },
        {
          id: "barbo",
          name: "Barbo",
          latin: "Luciobarbus bocagei",
          desc: "Força bruta do Guadiana. Combativo e incansável — um teste ao material e aos nós.",
          technique: "Fundeado · Spinning leve",
        },
      ],
    },
    gallery: {
      chapter: "Capítulo 03",
      title: "Galeria",
      heading: "Capturas que falam por si.",
      sub: "Alguns dos troféus dos nossos clientes no Grande Lago — cada foto é uma história.",
      captions: [
        "Lúcio-perca · Alqueva",
        "Barbo · Alqueva",
        "Achigã · Alqueva",
        "Troféu do dia · Alqueva",
        "Captura ao entardecer · Alqueva",
        "Jornada em família · Alqueva",
        "Achigã · Alqueva",
      ],
    },
    contact: {
      chapter: "Capítulo 04",
      title: "Contactos",
      ctaLine1: "VAMOS",
      ctaLine2: "PESCAR.",
      pricing: "Programas e preços sob consulta — jornadas de meio dia ou dia inteiro, feitas à medida.",
      labels: { whatsapp: "WhatsApp", phone: "Telefone", email: "Email", instagram: "Instagram", facebook: "Facebook" },
      follow: "Siga as nossas capturas",
      locationsLabel: "Zonas de embarque",
      locations: ["Monsaraz", "Campinho", "Amieira", "Alqueva", "Mourão"],
      footer: "© 2026 CebolaFishing Guide",
      location: "Barragem de Alqueva — Alentejo, Portugal",
    },
  },
  en: {
    nav: { about: "About", species: "Species", gallery: "Gallery", contact: "Contact" },
    hero: {
      kicker: "Alqueva Dam — Alentejo, Portugal",
      titleLines: ["GUIDED", "FISHING IN", "ALQUEVA"],
      sub: "Sport fishing trips on Europe's largest man-made lake. Largemouth bass, zander, pike and barbel — with a guide who knows every corner of the reservoir.",
      ctaPrimary: "Book a trip",
      ctaSecondary: "Meet the species",
      coords: "38.1975° N — 7.4961° W",
      scroll: "Scroll to explore",
    },
    marquee: ["BASS", "ZANDER", "PIKE", "BARBEL", "ALQUEVA"],
    about: {
      chapter: "Chapter 01",
      title: "About",
      heading: "The reservoir is our home water.",
      paragraphs: [
        "CebolaFishing Guide was born from a passion for sport fishing and for the Great Lake. At Alqueva — Europe's largest man-made lake, with over 1,100 kilometres of shoreline — every trip is planned in detail: the right spots, the right season, the right technique.",
        "From the bass smashing topwater at dawn to the zander hunting at dusk, through the mighty pike and the hard-fighting barbel — we guide anglers of all levels on tailor-made experiences.",
        "Alone, with friends or with family: bring the will to fish, we take care of the rest.",
      ],
      stats: [
        { value: "250 km²", label: "of open water" },
        { value: "83 km", label: "in length" },
        { value: "+1,100 km", label: "of shoreline" },
      ],
      imageCaption: "Golden hour on the Great Lake",
    },
    species: {
      chapter: "Chapter 02",
      title: "Species",
      heading: "Four opponents. One stage.",
      sub: "Each species demands a different reading of the water — and that's where our experience comes in.",
      techniqueLabel: "Techniques",
      items: [
        {
          id: "achiga",
          name: "Largemouth Bass",
          latin: "Micropterus salmoides",
          desc: "The king of Alqueva. Explosive, territorial and addictive — the predator that made the Great Lake famous.",
          technique: "Topwater · Soft plastics · Spinnerbait",
        },
        {
          id: "lucio-perca",
          name: "Zander",
          latin: "Sander lucioperca",
          desc: "A sharp-toothed twilight hunter. Demands patience, precision and reading the bottom.",
          technique: "Vertical · Jigging · Crankbait",
        },
        {
          id: "lucio-real",
          name: "Northern Pike",
          latin: "Esox lucius",
          desc: "The ambusher. Lightning strikes next to structure — pure adrenaline on every cast.",
          technique: "Jerkbait · Swimbait · Topwater",
        },
        {
          id: "barbo",
          name: "Iberian Barbel",
          latin: "Luciobarbus bocagei",
          desc: "Brute strength from the Guadiana. Relentless and hard-fighting — a test for tackle and knots.",
          technique: "Ledgering · Light spinning",
        },
      ],
    },
    gallery: {
      chapter: "Chapter 03",
      title: "Gallery",
      heading: "Catches that speak for themselves.",
      sub: "Some of our clients' trophies on the Great Lake — every photo is a story.",
      captions: [
        "Zander · Alqueva",
        "Barbel · Alqueva",
        "Bass · Alqueva",
        "Trophy of the day · Alqueva",
        "Dusk catch · Alqueva",
        "Family trip · Alqueva",
        "Bass · Alqueva",
      ],
    },
    contact: {
      chapter: "Chapter 04",
      title: "Contact",
      ctaLine1: "LET'S GO",
      ctaLine2: "FISHING.",
      pricing: "Trips and prices on request — half-day or full-day journeys, tailor-made.",
      labels: { whatsapp: "WhatsApp", phone: "Phone", email: "Email", instagram: "Instagram", facebook: "Facebook" },
      follow: "Follow our catches",
      locationsLabel: "Boarding points",
      locations: ["Monsaraz", "Campinho", "Amieira", "Alqueva", "Mourão"],
      footer: "© 2026 CebolaFishing Guide",
      location: "Alqueva Dam — Alentejo, Portugal",
    },
  },
  fr: {
    nav: { about: "Présentation", species: "Espèces", gallery: "Galerie", contact: "Contact" },
    hero: {
      kicker: "Barrage d'Alqueva — Alentejo, Portugal",
      titleLines: ["PÊCHE", "GUIDÉE À", "ALQUEVA"],
      sub: "Journées de pêche sportive sur le plus grand lac artificiel d'Europe. Achigan, sandre, brochet et barbeau — avec un guide qui connaît chaque recoin du barrage.",
      ctaPrimary: "Réserver une sortie",
      ctaSecondary: "Découvrir les espèces",
      coords: "38.1975° N — 7.4961° W",
      scroll: "Faites défiler pour explorer",
    },
    marquee: ["ACHIGAN", "SANDRE", "BROCHET", "BARBEAU", "ALQUEVA"],
    about: {
      chapter: "Chapitre 01",
      title: "Présentation",
      heading: "Le barrage est notre territoire.",
      paragraphs: [
        "CebolaFishing Guide est né de la passion pour la pêche sportive et pour le Grand Lac. Au barrage d'Alqueva — le plus grand lac artificiel d'Europe, avec plus de 1 100 kilomètres de rives — chaque sortie est planifiée dans les moindres détails : les bons spots, la bonne saison, la bonne technique.",
        "De l'achigan qui explose en topwater à l'aube, au sandre qui chasse au crépuscule, en passant par le puissant brochet et le combatif barbeau — nous guidons des pêcheurs de tous niveaux dans des expériences sur mesure.",
        "Seul, entre amis ou en famille : apportez l'envie de pêcher, nous nous occupons du reste.",
      ],
      stats: [
        { value: "250 km²", label: "de plan d'eau" },
        { value: "83 km", label: "de longueur" },
        { value: "+1 100 km", label: "de rives" },
      ],
      imageCaption: "Golden hour sur le Grand Lac",
    },
    species: {
      chapter: "Chapitre 02",
      title: "Espèces",
      heading: "Quatre adversaires. Une scène.",
      sub: "Chaque espèce demande une lecture différente de l'eau — et c'est là qu'intervient notre expérience.",
      techniqueLabel: "Techniques",
      items: [
        {
          id: "achiga",
          name: "Achigan",
          latin: "Micropterus salmoides",
          desc: "Le roi d'Alqueva. Explosif, territorial et addictif — le prédateur qui fait la renommée du Grand Lac.",
          technique: "Topwater · Leurres souples · Spinnerbait",
        },
        {
          id: "lucio-perca",
          name: "Sandre",
          latin: "Sander lucioperca",
          desc: "Chasseur crépusculaire aux dents acérées. Exige patience, précision et lecture des fonds.",
          technique: "Vertical · Jigging · Crankbait",
        },
        {
          id: "lucio-real",
          name: "Brochet",
          latin: "Esox lucius",
          desc: "L'embuscadeur. Des attaques fulgurantes près des structures — de l'adrénaline pure à chaque lancer.",
          technique: "Jerkbait · Swimbait · Surface",
        },
        {
          id: "barbo",
          name: "Barbeau",
          latin: "Luciobarbus bocagei",
          desc: "La force brute du Guadiana. Combatif et infatigable — un test pour le matériel et les nœuds.",
          technique: "Pêche au posé · Spinning léger",
        },
      ],
    },
    gallery: {
      chapter: "Chapitre 03",
      title: "Galerie",
      heading: "Des prises qui parlent d'elles-mêmes.",
      sub: "Quelques trophées de nos clients sur le Grand Lac — chaque photo est une histoire.",
      captions: [
        "Sandre · Alqueva",
        "Barbeau · Alqueva",
        "Achigan · Alqueva",
        "Trophée du jour · Alqueva",
        "Prise au crépuscule · Alqueva",
        "Sortie en famille · Alqueva",
        "Achigan · Alqueva",
      ],
    },
    contact: {
      chapter: "Chapitre 04",
      title: "Contact",
      ctaLine1: "ALLONS",
      ctaLine2: "PÊCHER.",
      pricing: "Programmes et prix sur demande — sorties d'une demi-journée ou d'une journée complète, sur mesure.",
      labels: { whatsapp: "WhatsApp", phone: "Téléphone", email: "Email", instagram: "Instagram", facebook: "Facebook" },
      follow: "Suivez nos prises",
      locationsLabel: "Points d'embarquement",
      locations: ["Monsaraz", "Campinho", "Amieira", "Alqueva", "Mourão"],
      footer: "© 2026 CebolaFishing Guide",
      location: "Barrage d'Alqueva — Alentejo, Portugal",
    },
  },
};
